export const isValidMobileNo = (mobileNo: string): boolean => {
  // Valid Indian mobile numbers: exactly 10 digits, starting with 6, 7, 8, or 9
  return /^[6-9]\d{9}$/.test(mobileNo);
};


export const isTextboxHasOnlyNumbers = (value: string): boolean => {
  // Allow only digits, max length 10
  if (/^\d{0,10}$/.test(value)) {
    return true;
  }
  return false;
};
